import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e84e807"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center ga-1 mb-2"
}
const _hoisted_2 = {
  key: 0,
  class: "text-wrap"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "text-wrap"
}

import { Torneo } from "@/interfaces/Torneo";
import { esPorJornadas, nombreEvento } from "@/Constant/FormatoTorneo";
import { diaDeHoy, formatFechaSpa, formatFechaSpaWhitoutAsync, formatHora, ultimoDiaEvento } from "@/utils/Fecha";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TorneoCard',
  props: {
    torneo: {},
    verClasificacion: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
// Liga o Copa
const esLiga = computed(() => esPorJornadas(props.torneo.formatoTorneo));
const ultimoDia = computed(() =>
  ultimoDiaEvento(props.torneo.fechaInicioTorneo, props.torneo.fechaFinTorneo)
);
const variosDias = computed(() => ultimoDia.value > props.torneo.fechaInicioTorneo.slice(0, 10));
// Ya empezado y sin terminar: una liga a mitad o un torneo que se juega hoy
const enCurso = computed(
  () => props.torneo.fechaInicioTorneo.slice(0, 10) <= diaDeHoy() && ultimoDia.value >= diaDeHoy()
);
const router = useRouter();
const fechaTorneo = ref<string>("");

// Variables reactivas
const formattedAddress = ref<string>("");

// Computed property para generar el enlace a Google Maps
const googleMapsUrl = computed(() => {
  if (!props.torneo.lugarTorneo) return "#";
  return `https://www.google.com/maps?q=${parseFloat(
    props.torneo.lugarTorneo.split(", ")[0]
  )},${parseFloat(props.torneo.lugarTorneo.split(", ")[1])}`;
});

// Función para obtener dirección inversa desde coordenadas
const getAddress = async (lat: number, lon: number) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;
  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.address) {
      const { road, house_number, city, town, village, state, postcode } =
        data.address;

      // Priorizar ciudad, pueblo o aldea
      const locationCity = city || town || village || "";

      // Construir dirección formateada
      formattedAddress.value = [
        road ? `${road}${house_number ? `, ${house_number}` : ""}` : "",
        locationCity,
        state,
        postcode,
      ]
        .filter(Boolean) // Eliminar valores vacíos
        .join(", "); // Unir con comas
    } else {
      formattedAddress.value = "Dirección no disponible";
    }
  } catch (error) {
    console.error("Error obteniendo la dirección:", error);
  }
};
const isValidCoordinates = (value: string): boolean => {
  if (!value) return false;

  // Expresión regular para validar coordenadas (lat, lng)
  const regex = /^-?\d{1,2}\.\d+,\s*-?\d{1,3}\.\d+$/;

  return regex.test(value.trim());
};

onMounted(async () => {
  fechaTorneo.value = await formatFechaSpa(props.torneo.fechaInicioTorneo);
  if (isValidCoordinates(props.torneo.lugarTorneo)) {
    getAddress(
      parseFloat(props.torneo.lugarTorneo.split(", ")[0]),
      parseFloat(props.torneo.lugarTorneo.split(", ")[1])
    );
  }
});

const goToDetalle = () => {
  router.push(`/detalle-evento/${props.torneo.idTorneo}`);
};

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "pa-3",
    link: "",
    onClick: goToDetalle
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_img, {
        src: _ctx.torneo.cartelTorneo || require('@/assets/images/cartelMissing.jpg'),
        height: "250px",
        class: "rounded-lg"
      }, null, 8, ["src"]),
      _createVNode(_component_v_divider, { class: "my-3" }),
      _createVNode(_component_v_card_title, { class: "ringbearer text-h6 text-center text-wrap font-weight-bold mt-3" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.torneo.nombreTorneo), 1)
        ]),
        _: 1
      }),
      (esLiga.value || enCurso.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (esLiga.value)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  size: "small",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(nombreEvento)(_ctx.torneo.formatoTorneo)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (enCurso.value)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 1,
                  size: "small",
                  color: "success",
                  "prepend-icon": "mdi-sword-cross"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("En curso")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (formattedAddress.value.trim() || _ctx.torneo.lugarTorneo?.trim())
        ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
            key: 1,
            class: "text-center mb-3"
          }, {
            default: _withCtx(() => [
              (formattedAddress.value.trim())
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                    _createElementVNode("a", {
                      href: googleMapsUrl.value,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, _toDisplayString(formattedAddress.value), 9, _hoisted_3)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.torneo.lugarTorneo), 1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider, { class: "my-3" }),
      _createVNode(_component_v_card_text, { class: "text-center py-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            start: "",
            color: "green"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-calendar")
            ]),
            _: 1
          }),
          (variosDias.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Del " + _toDisplayString(fechaTorneo.value) + " al " + _toDisplayString(_unref(formatFechaSpaWhitoutAsync)(ultimoDia.value)), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(fechaTorneo.value) + " ", 1),
                (!esLiga.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" a las " + _toDisplayString(_unref(formatHora)(_ctx.torneo.horaInicioTorneo)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})